/* eslint-disable no-console */
export function setSite(site) {
    console.log('setSite:', site);
    return {
        type: 'SET_SITE',
        payload: site
    };
}


// WEBPACK FOOTER //
// ./src/universal/actions/action_site.js